// src/components/MaxWidthText.tsx
import { styled } from "@mui/material";
var MaxWidthText = styled("div")`
    max-width: 70ch;
`;
var MaxWidthText_default = MaxWidthText;

export {
  MaxWidthText,
  MaxWidthText_default
};
//# sourceMappingURL=chunk-5273EXIO.js.map